// extracted by mini-css-extract-plugin
module.exports = {"carouseTitle":"my","icon":"mz","emblaSlide":"mA"};